// Подписи и доступность объектов для ограниченных публичных ссылок календаря —
// общие для строки ссылки (PublicLinkItem) и формы (PublicLinkFormDialog).
// Работают по данным manage-эндпоинтов кабинета: там есть и неактивные объекты,
// поэтому у ранее выбранных, но уже недоступных вариантов остаётся название.

export const expertName = (expert) => `${expert.first_name || ''} ${expert.last_name || ''}`.trim();

export const expertLabel = (experts, id) => {
  const expert = experts.find((item) => item.id === id);
  return expert ? expertName(expert) : `Эксперт #${id}`;
};

export const serviceTypeLabel = (serviceTypes, id) => {
  const serviceType = serviceTypes.find((item) => item.id === id);
  return serviceType ? serviceType.name : `Тип услуги #${id}`;
};

// BookableService: в manage-API expert и service_type — ID.
export const serviceLabel = (services, serviceTypes, id) => {
  const service = services.find((item) => item.id === id);
  if (!service) return `Услуга #${id}`;
  return `${serviceTypeLabel(serviceTypes, service.service_type)}, ${service.max_duration_minutes} мин`;
};

const isActive = (item) => Boolean(item) && item.is_active !== false;

export const isServiceAvailable = (services, id) => isActive(services.find((item) => item.id === id));

// Эксперт подходит ссылке на тип услуги, если он активен и оказывает этот тип через активную услугу.
export const isExpertAvailableForType = (experts, services, expertId, serviceTypeId) => (
  isActive(experts.find((item) => item.id === expertId))
  && services.some((item) => item.expert === expertId && item.service_type === serviceTypeId && isActive(item))
);

// Название ссылки: заданное вручную (name) или автоматическое — эксперт / тип услуги.
export const linkTitle = (kind, link, experts, serviceTypes) => {
  if (link.name && link.name.trim()) return link.name.trim();
  return kind === 'expert'
    ? expertLabel(experts, link.expert)
    : serviceTypeLabel(serviceTypes, link.service_type);
};

// Эксперт участвует в ссылке на тип услуги, если выбран в ней явно или ссылка открыта
// для всех экспертов и он оказывает этот тип.
export const isExpertInServiceLink = (experts, services, expertId, link) => {
  const selected = link.experts || [];
  if (selected.length) return selected.includes(expertId);
  return isExpertAvailableForType(experts, services, expertId, link.service_type);
};
